var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('v-container',[_c('v-row',[_c('v-col',{staticClass:"text-center",attrs:{"md":"12"}},[_c('h1',[_vm._v("Welcome to snapshot")]),_c('h3',[_vm._v("Please login to facebook")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }